const timezoneList = new Array(
  ['安道尔 · 安道尔 (Andorra Andorra)', 'A', '1'],
  ['阿尔及利亚 · 阿尔及尔 (Algeria Algiers)', 'A', '2'],
  ['阿尔巴尼亚 · 地拉那 (Albania Tirana)', 'A', '3'],
  ['奥地利 · 维也纳 (Austria·Vienna)', 'A', '4'],
  ['澳洲 · 伯斯 (Australia·Perth)', 'H', '5'],
  ['澳洲 · 布里斯本 (Australia·Brisbane)', 'K', '7'],
  ['澳洲 · 墨尔本 (Australia·Melbourne)', 'K', '8'],
  ['澳洲 · 昆士兰 (Australia·Queensland)', 'K', '9'],
  ['澳洲 · 悉尼 (Australia·Sydney)', 'K', '10'],
  ['阿联酋 · 阿布达比 (UAE·Abu Dhabi)', 'D', '12'],
  ['阿联酋 · 杜拜 (UAE Dubai)', 'D', '13'],
  ['阿曼 · 马斯喀特 (Oman Muscat)', 'D', '14'],
  ['阿根廷 · 布宜洛斯艾利斯 (Argentina Buenos Aires)', 'P', '16'],
  ['阿拉斯加 · 安克雷奇 (Alaska Anchorage)', 'V', '17'],
  ['埃尼威托克 (ENiwetok)', 'Y', '18'],
  ['埃及 · 开罗 (Egypt Cairo)', 'B', '19'],
  ['埃塞俄比亚 (Ethiopia)', 'C', '20'],
  ['比利时 · 布鲁塞尔 (Belgium·Brussels)', 'A', '21'],
  ['波兰 · 华沙 (Poland Warsaw)', 'A', '22'],
  ['波札那 · 嘉柏隆 (Botswana Gaboron)', 'B', '23'],
  ['保加利亚 · 索非亚 (Bulgaria·Sofia)', 'B', '24'],
  ['巴基斯坦 · 伊斯兰堡 (Pakistan·Islamabad)', 'E', '25'],
  ['巴基斯坦 · 喀拉蚩 (Pakistan·Karachi)', 'E', '26'],
  ['巴西 · 巴西利亚 (Brazil·Brasilia)', 'P', '27'],
  ['巴西 · 里约热内卢 (Brazil Rio de Janeiro)', 'P', '28'],
  ['巴巴多斯 · 布里奇敦 (Barbados Bridgetown)', 'Q', '29'],
  ['巴布亚新畿内亚 (Papua New Guinea)', 'K', '30'],
  ['百慕达 · 哈密尔顿 (Bermuda Hamilton)', 'Q', '31'],
  ['玻利维亚 · 拉巴斯 (Bolivia La Paz)', 'Q', '32'],
  ['巴拉圭 · 亚松森 (Paraguay Asuncion)', 'Q', '33'],
  ['巴哈马 · 拿骚 (Bahamas Nassau)', 'R', '34'],
  ['巴拿马 · 巴拿马城 (Panama Panama City)', 'R', '35'],
  ['冰岛 · 雷克雅未克 (Iceland Reykjavik)', 'Z', '36'],
  ['北韩 · 平壤 (North Korea·Pyongyang)', 'I', '37'],
  ['德国 · 柏林 (Germany·Berlin)', 'A', '38'],
  ['丹麦 · 哥本哈根 (Denmark·Copenhagen)', 'A', '39'],
  ['德国 · 法兰克福 (Germany Frankfurt)', 'A', '40'],
  ['德国 · 汉堡 (Germany Hamburg)', 'A', '41'],
  ['达累斯萨拉姆 (Dar es Salaam)', 'C', '42'],
  ['多米尼加共和国 (Dominican Republic)', 'Q', '43'],
  ['多米尼克 · 罗索 (Dominic Rosso)', 'Q', '44'],
  ['俄罗斯 · 莫斯科 (Russia Moscow)', 'C', '45'],
  ['厄瓜多尔 · 基多 (Ecuador Quito)', 'R', '46'],
  ['法国 · 里昂 (France·Lyon)', 'A', '47'],
  ['法国 · 巴黎 (France·Paris)', 'A', '48'],
  ['芬兰 · 赫尔辛基 (Finland Helsinki)', 'B', '49'],
  ['佛得角 · 普拉亚 (Cape Verde Praia)', 'N', '50'],
  ['菲律宾 · 马尼拉 (Philippines Manila)', 'H', '51'],
  ['斐济 · 苏瓦 (Fiji Suva)', 'M', '52'],
  ['刚果 · 布拉柴维尔 (Congo Brazzaville)', 'A', '53'],
  ['哥伦比亚 · 波哥大 (Colombia Bogotá)', 'R', '54'],
  ['古巴 · 哈瓦那 (Cuba Havana)', 'R', '55'],
  ['哥斯达黎加 · 圣荷塞 (Costa Rica San Jose)', 'S', '56'],
  ['甘比尔群岛 (Gambier Islands)', 'V', '57'],
  ['荷兰 · 阿姆斯特丹 (Netherlands Amsterdam)', 'A', '58'],
  ['荷兰 · 罗索 (Netherlands Rosso)', 'A', '59'],
  ['荷属安的列斯群岛 (Netherlands Antilles)', 'Q', '60'],
  ['洪都拉斯 · 特古西加尔巴 (Honduras Tegucigalpa)', 'S', '61'],
  ['惠森迪岛 (Whisendi Island)', 'K', '62'],
  ['捷克 · 布拉格 (Czech Prague)', 'A', '63'],
  ['津巴布韦 · 哈拉雷 (Zimbabwe Harare)', 'B', '64'],
  ['柬浦寨 · 金边 (Cambodia · Phnom Penh)', 'G', '65'],
  ['基里巴斯共和国 (Kiribati)', 'M2', '66'],
  ['加拿大 · 新斯科舍 (Canada·Nova Scotia)', 'Q', '68'],
  ['加拿大 · 蒙特利尔 (Canada·Montreal)', 'R', '69'],
  ['加拿大 · 渥太华 (Canada·Ottawa)', 'R', '70'],
  ['加拿大 · 多伦多 (Canada·Toronto)', 'R', '71'],
  ['加拿大 · 温尼伯 (Canada·Winnipeg)', 'S', '72'],
  ['加拿大 · 埃德蒙顿 (Canada·Edmonton)', 'T', '73'],
  ['加拿大 · 温哥华 (Canada·Vancouver)', 'U', '74'],
  ['加纳 · 阿克拉 (Ghana·Accra)', 'Z', '75'],
  ['喀密隆 · 雅温得 (Cameroon Yaounde)', 'A', '76'],
  ['科威特 · 科威特 (Kuwait·Kuwait)', 'C', '77'],
  ['肯雅 · 奈洛比 (Kenya Nairobi)', 'C', '78'],
  ['卢森堡 (Luxembourg)', 'A', '79'],
  ['黎巴嫩 · 贝鲁特 (Lebanon Beirut)', 'B', '80'],
  ['罗马尼亚 · 布加勒斯特 (Romania Bucharest)', 'B', '81'],
  ['美国 · 马里兰 (United States·Maryland)', 'R', '82'],
  ['美国 · 新泽西 (United States·New Jersey)', 'R', '83'],
  ['美国 · 纽约 (United States·New York)', 'R', '84'],
  ['美国 · 费城 (United States·Philadelphia)', 'R', '85'],
  ['美国 · 华盛顿 (United States·Washington)', 'R', '86'],
  ['美国 · 芝加哥 (United States·Chicago)', 'S', '87'],
  ['美国 · 亚特兰大 (United States Atlanta)', 'R', '88'],
  ['美国 · 波士顿 (United States·Boston)', 'R', '89'],
  ['美国 · 达拉斯 (United States·Dallas)', 'S', '90'],
  ['美国 · 休斯敦 (USA·Houston)', 'S', '91'],
  ['美国 · 威斯康辛 (USA·Wisconsin)', 'S', '92'],
  ['美国 · 蒙大拿 (USA·Montana)', 'T', '93'],
  ['美国 · 新墨西哥 (United States · New Mexico)', 'T', '94'],
  ['美国 · 圣迭戈 (United States·San Diego)', 'T', '95'],
  ['美国 · 加利福尼亚 (United States·California)', 'U', '96'],
  ['美国 · 拉斯维加斯 (United States· Las Vegas)', 'U', '97'],
  ['美国 · 洛杉机 (USA·Los Angeles)', 'U', '98'],
  ['美国 · 三藩市 (USA·San Francisco)', 'U', '99'],
  ['美国 · 西雅图 (United States·Seattle)', 'U', '100'],
  ['美国 · 夏威夷 (United States·Hawaii)', 'W', '101'],
  ['美国 · 檀香山 (United States·Honolulu)', 'W', '102'],
  ['马来西亚 · 吉隆坡 (Malaysia·Kuala Lumpur)', 'H', '103'],
  ['孟加拉 · 达卡 (Bangladesh·Dhaka)', 'F', '104'],
  ['秘鲁 · 利马 (Peru · Lima)', 'R', '106'],
  ['摩洛哥 · 卡萨布兰卡 (Morocco Casablanca)', 'Z', '107'],
  ['摩洛哥 · 拉巴特 (Morocco Rabat)', 'Z', '108'],
  ['莫尔兹比港 (Port Moresby)', 'K', '109'],
  ['墨西哥 · 墨西哥城 (Mexico·Mexico City)', 'S', '110'],
  ['尼日利亚 · 阿布贾 (Nigeria·Abuja)', 'A', '111'],
  ['挪威 · 奥斯陆 (Norway Oslo)', 'A', '112'],
  ['南非 · 开普敦 (South Africa Cape Town)', 'B', '113'],
  ['南非 · 约翰尼斯堡 (South Africa Johannesburg)', 'B', '114'],
  ['南韩 · 汉城/首尔 (South Korea·Seoul/Seoul)', 'I', '115'],
  ['葡萄牙 · 里斯本 (Portugal·Lisbon)', 'Z', '116'],
  ['瑞士 · 伯恩 (Switzerland·Bern)', 'A', '117'],
  ['瑞典 · 斯德哥尔摩 (Sweden·Stockholm)', 'A', '118'],
  ['瑞士 · 苏黎世 (Switzerland·Zurich)', 'A', '119'],
  ['日本 · 扎幌 (Japan·Sapporo)', 'I', '120'],
  ['日本 · 东京 (Japan·Tokyo)', 'I', '121'],
  ['日本 · 大坂 (Japan·Daban)', 'I', '122'],
  ['苏丹 · 喀土木 (Sudan Khartoum)', 'B', '123'],
  ['尚比亚 · 路沙卡 (Zambia Lusaka)', 'B', '124'],
  ['塞普路斯 · 尼古西亚 (Cyprus Nicosia)', 'B', '125'],
  ['沙特阿拉伯 · 利雅德 (Saudi Arabia·Riya De)', 'C', '126'],
  ['斯里兰卡 · 可伦坡 (Sri Lanka Colombo)', 'F', '127'],
  ['圣多明各 (Santo Domingo)', 'Q', '129'],
  ['萨尔瓦多 · 圣萨尔瓦多 (El Salvador San Salvador)', 'S', '130'],
  ['塞内加尔 · 达喀尔 (Senegal Dakar)', 'Z', '131'],
  ['斯里巴加湾 (Seri Begawan)', 'H', '132'],
  ['土耳其 · 伊斯坦布尔 (Turkey·Istanbul)', 'B', '133'],
  ['坦桑尼亚 (Tanzania)', 'C', '134'],
  ['泰国 · 曼谷 (Thailand·Bangkok)', 'G', '135'],
  ['泰国 · 布吉 (Thailand·Buji)', 'G', '136'],
  ['特林达迪岛 (Trindade Island)', 'O', '137'],
  ['乌干达 · 坎帕拉 (Uganda·Kampala)', 'C', '138'],
  ['乌拉圭 · 蒙得维的亚 (Uruguay Montevideo)', 'P', '139'],
  ['威廉斯塔德 (Williamstad)', 'Q', '140'],
  ['危地马拉 · 危地马拉城 (Guatemala·Guatemala City)', 'S', '141'],
  ['汶莱 (Brunei)', 'H', '142'],
  ['西班牙 · 巴塞隆纳 (Spain·Barcelona)', 'A', '143'],
  ['匈牙利 · 布达佩斯 (Hungary·Budapest)', 'A', '144'],
  ['西班牙 · 马德里 (Spain·Madrid)', 'A', '145'],
  ['希腊 · 雅典 (Greece·Athens)', 'B', '146'],
  ['新加坡 (Singapore)', 'H', '147'],
  ['新西兰 · 威灵顿 (New Zealand Wellington)', 'M', '148'],
  ['新喀里多尼亚 · 努美阿 (New Caledonia Nouméa)', 'L', '149'],
  ['新西兰 · 奥克兰 (New Zealand Auckland)', 'M', '150'],
  ['意大利 · 米兰 (Italy Milan)', 'A', '151'],
  ['意大利 · 罗马 (Italy Rome)', 'A', '152'],
  ['以色列 · 耶路撒冷 (Israel Jerusalem)', 'B', '153'],
  ['亚的斯亚贝巴 (Addis Ababa)', 'C', '154'],
  ['也门 · 萨那 (Yemen Sana)', 'C', '155'],
  ['越南 · 河内 (Vietnam·Hanoi)', 'G', '160'],
  ['印尼 · 雅加达 (Indonesia·Jakarta)', 'G', '161'],
  ['牙买加 · 金斯敦 (Jamaica·Kingston)', 'R', '162'],
  ['英国 · 阿伯丁 (United Kingdom·Aberdeen)', 'Z', '163'],
  ['英国 · 爱丁堡 (United Kingdom·Edinburgh)', 'Z', '164'],
  ['英国 · 格拉斯哥 (United Kingdom·Glasgow)', 'Z', '165'],
  ['英国 · 利物浦 (United Kingdom·Liverpool)', 'Z', '166'],
  ['英国 · 伦敦 (United Kingdom·London)', 'Z', '167'],
  ['英国 · 曼彻斯特 (United Kingdom·Manchester)', 'Z', '168'],
  ['英国 · 纽卡素 (United Kingdom·Newcastle)', 'Z', '169'],
  ['中国 · 北京 (China·Beijing)', 'H', '170'],
  // ['中国 · 重庆 (China·Chongqing)', 'H', '171'],
  // ['中国 · 广州 (China·Guangzhou)', 'H', '172'],
  // ['中国 · 哈尔滨 (China·Harbin)', 'H', '173'],
  // ['中国 · 香港 (China·Hongkong)', 'H', '174'],
  // ['中国 · 澳门 (China·Macao)', 'H', '175'],
  // ['中国 · 南京 (China·Nanjing)', 'H', '176'],
  // ['中国 · 上海 (China·Shanghai)', 'H', '177'],
  // ['中国 · 台北 (China·Taipei)', 'H', '178'],
  // ['中国 · 乌鲁木齐 (China·Urumqi)', 'H', '179'],
  ['中途岛 (Midway Island)', 'X', '180'],
  ['智利 · 圣地亚哥 (Chile·Santiago)', 'Q', '181']
);

const zoneList = {
  "A": "1",
  "B": "2",
  "C": "3",
  "D": "4",
  "E": "5",
  "F": "6",
  "G": "7",
  "H": "8",
  "I": "9",
  "K": "10",
  "L": "11",
  "M": "12",
  "M2": "13",
  "N": "-1",
  "O": "-2",
  "P": "-3",
  "Q": "-4",
  "R": "-5",
  "S": "-6",
  "T": "-7",
  "U": "-8",
  "V": "-9",
  "W": "-10",
  "X": "-11",
  "Y": "-12",
  "Z": "0"
};

const timezoneTime = (arg) => {

  const zoneKey = arg.split('_')[0];

  let d = new Date();
  let len = d.getTime();
  let offset = d.getTimezoneOffset() * 60000;
  let utcTime = len + offset;

  let dZone = new Date(utcTime + 3600000 * Number(zoneList[zoneKey]));
  return dZone.Format('yyyy-MM-dd HH:mm:ss');
}

const local2Zone = (milliTime, arg) => {
  const zoneKey = arg.split('_')[0];
  let utcTime = milliTime + new Date().getTimezoneOffset() * 60000;
  return utcTime + 3600000 * Number(zoneList[zoneKey]);
}

const toZoneTime = (dateStr, hours, arg) => {

  const zoneKey = arg.split('_')[0];

  let gmt8Time = Date.parse(dateStr + ' ' + hours + ':00:00 GMT +8');
  let utcTime = gmt8Time + new Date().getTimezoneOffset() * 60000;
  return utcTime + 3600000 * Number(zoneList[zoneKey]);
  // console.log('d>>', d);
  // let d = new Date(new Date(dateStr).setHours(hours));
  // let len = d.getTime();
  // let offset = d.getTimezoneOffset() * 60000;
  // let utcTime = len + offset;

  // let dZone = new Date(utcTime + 3600000 * Number(zoneList[zoneKey]));
  // return dZone.Format('yyyy-MM-dd HH:mm:ss');
}
const toZoneTimeStr = (dateStr, hours, arg) => {

  const zoneKey = arg.split('_')[0];

  let gmt8Time = Date.parse(dateStr + ' ' + hours + ':00:00 GMT +8');
  let utcTime = gmt8Time + new Date().getTimezoneOffset() * 60000;
  let dZone = new Date(utcTime + 3600000 * Number(zoneList[zoneKey]));
  return dZone.Format('yyyy-MM-dd HH:mm:ss');
}

const toGMT8Time = (dateStr, hours, arg) => {
  let gmt8Time = Date.parse(dateStr + ' ' + hours + ':00:00 GMT +8');
  let utcTime = gmt8Time + new Date().getTimezoneOffset() * 60000;
  return utcTime + 3600000 * 8;
}
const toGMT8yyyyMMdd = (date) => {
  let utcTime = date.getTime() + new Date().getTimezoneOffset() * 60000;
  let gmt8Time = utcTime + 480 * 60000;
  return new Date(gmt8Time).Format('yyyy-MM-dd');
}
const toGMT8yyyyMMddHHmmss = (date) => {
  let utcTime = date.getTime() + new Date().getTimezoneOffset() * 60000;
  let gmt8Time = utcTime + 480 * 60000;
  return new Date(gmt8Time).Format('yyyy-MM-dd HH:mm:ss');
}
const bj2LocalyyyyMMdd = (dateStr, hours) => {
  let gmt8Time = Date.parse(dateStr + ' ' + hours + ':00:00 GMT +8');
  // let utcTime = gmt8Time - 480 * 60000;
  // let localTime = utcTime - new Date().getTimezoneOffset() * 60000;
  return new Date(gmt8Time).Format('yyyy-MM-dd');
}
const bj2LocalyyyyMMddHHmmss = (dateStr, hours) => {
  let gmt8Time = Date.parse(dateStr + ' ' + hours + ':00:00 GMT +8');
  // let utcTime = gmt8Time - 480 * 60000;
  // let localTime = utcTime - new Date().getTimezoneOffset() * 60000;
  return new Date(gmt8Time).Format('yyyy-MM-dd HH:mm:ss');
}

const millsSecond = (dateStr, hours) => {
  let gmt8Time = Date.parse(dateStr + ' ' + hours + ':00:00 GMT +8');
  return gmt8Time;
}


const zoneName = (arg) => {
  const arg1 = arg.split('_')[0];
  const arg2 = arg.split('_')[1];

  const zone = timezoneList.filter(zone => {
    return zone[1] == arg1 && zone[2] == arg2;
  });
  if (zone[0]) {
    return zone[0][0];
  }
  return '';
}

const zoneOffset = (arg) => {
  const arg1 = arg.split('_')[0];
  return zoneList[arg1] || '';
}

export default {
  timezoneList,
  timezoneTime,
  toZoneTime,
  zoneName,
  zoneOffset,
  toGMT8Time,
  toGMT8yyyyMMdd,
  toGMT8yyyyMMddHHmmss,
  bj2LocalyyyyMMdd,
  bj2LocalyyyyMMddHHmmss,
  local2Zone,
  millsSecond
}
